import React from 'react'
import { useParams } from 'react-router-dom'
import useHotels from '../../../hooks/useHotels'
import logo from '../../../images/logo2.png'
import Header from '../../Shared/Header/Header'
import '../../Shared/LoadingSpinner/LoadingSpinner'
import LoadingSpinner from '../../Shared/LoadingSpinner/LoadingSpinner'
import CoxHotels from './CoxHotels'
import SajekHotels from './SajekHotels'
import SreemangalHotels from './SreemangalHotels'
import SundarbanHotels from './SundarbanHotels'

const Destination = () => {
    const {name} = useParams()
    const [hotels, loading] = useHotels()

    return (
        <div>
            <Header>{logo}</Header>
            {
                loading ? <LoadingSpinner/> :
                <>
                    {name === "cox's-bazar" && <CoxHotels name={name} hotels={hotels.slice(0,3)}/>}
                    {name === "sreemangal" && <SreemangalHotels name={name} hotels={hotels.slice(3,6)}/>}
                    {name === "sundarban" && <SundarbanHotels name={name} hotels={hotels.slice(6,9)}/>}
                    {name === "sajek" && <SajekHotels name={name} hotels={hotels.slice(9,12)}/>} 
                </>
            }

        </div>
    )
}

export default Destination
